import $ from 'jquery'

export default () => {
    $('a[href*="#"].scroll-down').on('click', function (el) {
        let target = $(this).attr('href')

        if (!target.startsWith('#')) {
            let url = new URL(target)

            if (url.pathname !== window.location.pathname) {
                return
            }

            target = url.hash
        }

        el.preventDefault()

        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 1000, 'linear')
    })
}
